/*
 * Copyright (c) 2020 CalAmp Corp.  All Rights Reserved
 */
import React, {memo} from 'react';
import PartnerLogo from '@ion/dls/src/logo/PartnerLogo';
import {shouldIncludeCalAmpReference} from '@ion/dls/src/theme/resellers/Resellers';
import useReseller from '@ion/dls/src/theme/resellers/useReseller';
import {dlsColor} from '@ion/dls/src/theme/theme';
import {useThemeMode} from '@ion/dls/src/theme/useThemeContext';
import Logo from '@/components/logo/IOnSuiteLogo';
import styles from './DesktopHeader.module.scss';

/**
 * @DesktopHeaderLogo
 *
 * The Desktop Header Logo component provides the application Header
 * Logo for the iOn Application
 * when view in Desktop Mode.
 */
export const DesktopHeaderLogo = () => {
  const {isReseller} = useReseller();
  // re-renders on a light/dark switch, so the logo fill follows the mode ...
  useThemeMode();
  if (!isReseller) {
    return (
      <div className={styles.logo} style={{flexGrow: 1}}>
        <Logo width={47} height={23} fill={dlsColor('caBlue')} />
      </div>
    );
  }
  return <PartnerLogo isHeader showAffiliateLogo={shouldIncludeCalAmpReference(false)} />;
};

export default memo(DesktopHeaderLogo);
